import ErrorCodeHelper from '@dealroadshow/error-codes';
import { RpcError } from '@dealroadshow/json-rpc-dispatcher';
import { getMessageByErrorCode } from '@framework/message/Mapper/getMessage';

import { History } from '@framework/di/Providers/History';
import { SessionService } from '@users/session/SessionService';
import Store from '@framework/di/Providers/Redux/Store';
import type { IResponseInterceptor } from '@dealroadshow/json-rpc-dispatcher';

// TODO: type as Container once the DI tokens here (Store, History) stop being bare symbols —
// with untyped tokens `container.get()` returns `unknown` and the `any` only moves to each call site.
export default (container: any): IResponseInterceptor => async (response) => {
  if (!(response instanceof RpcError)) {
    return response;
  }

  const errorCode = response.getCode();
  const errorCodes = [
    ErrorCodeHelper.getCodeByName('SESSION_PERMISSION_DENIED'),
    ErrorCodeHelper.getCodeByName('SESSION_NOT_ADMIN'),
  ];

// @ts-ignore TODO: FIN-32798 strictNullChecks
  if (errorCodes.includes(errorCode)) {
    const sidebarList = container.get(Store).getState().condor?.sidebar?.navigationItems;

    if (!sidebarList) {
      const sessionService: SessionService = container.get(SessionService);
      sessionService.logout();
      return response;
    }

    const history = container.get(History);
    const isApplicationFirst = sidebarList[0].id === 'prod_label';
    const availableRoute = isApplicationFirst ? sidebarList[1].href : sidebarList[0].href;
    if (availableRoute) {
      history.push(availableRoute);
      if (typeof window !== 'undefined') {
        import('@dealroadshow/uikit-alert').then(({ AlertManager }) => {
// @ts-ignore TODO: FIN-32798 strictNullChecks
          AlertManager.error(getMessageByErrorCode(errorCode));
        });
      }
    } else {
      const sessionService: SessionService = container.get(SessionService);
      sessionService.logout();
    }
  }

  return response;
};
